__turbopack_context__.v({
  "partner": "Provider-module-scss-module__TC0enW__partner",
  "providerContainer": "Provider-module-scss-module__TC0enW__providerContainer",
});
